"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=CognitoProviderParameters.js.map